module.exports = __webpack_public_path__ + "static/media/verification-active.98821809.svg";